import { render, staticRenderFns } from "./viewArticles.vue?vue&type=template&id=1ed5358c&"
import script from "./viewArticles.vue?vue&type=script&lang=js&"
export * from "./viewArticles.vue?vue&type=script&lang=js&"
import style0 from "./viewArticles.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports